module.exports = __webpack_public_path__ + "img/LB001933.cfa23b3b.png";